import Media from "apiEndPoints/Media";
import { Upload } from "components/Antd";
import { useState } from "react";

function Step2Uploader({
  props,
  memorialData,
  theme,
  subscriptionData,
  setCoverImageSize,
}) {
  const [coverUrl, setCoverUrl] = useState();
  const ratios = {
    theme02: 2.2,
    theme04: 1.55,
  };

  return (
    <div className="customUpload customUpload-icon customUpload-w100 mb-2 mb-lg-0">
      <Upload
        name="coverImage"
        setFieldValue={props.handleChange}
        apiEndPoints={Media.mediaUpload("memorial", "image")}
        query
        applyImageCropper
        aspect={ratios?.[theme]}
        aspectSlider
        imageUrl={coverUrl}
        setImageUrl={setCoverUrl}
        setImageSize={setCoverImageSize}
        validateStatus
        subscriptionData={subscriptionData}
        defaultImageUrl={memorialData?.themeOnes?.[0]?.coverImageUrl}
        fileSize
      >
        <div>
          <em className="icon-upload" />
          <span className="d-block">Upload Profile Image</span>
        </div>
      </Upload>
    </div>
  );
}

export default Step2Uploader;
